import { render, staticRenderFns } from "./PartAssignment.vue?vue&type=template&id=ae87a69e&"
import script from "./PartAssignment.vue?vue&type=script&lang=js&"
export * from "./PartAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports